export default "./images/survio-7Ap-B-font-Flaticon.svg";